import { Input } from "@/components/ui/input";
import { Field, useFieldError } from "@/shared/forms/Field";
import type * as React from "react";
import { Controller, useFormContext } from "react-hook-form";

type FormNumberProps = Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  "type"
> & {
  name: string;
  label?: React.ReactNode;
  hint?: React.ReactNode;
  requiredMark?: boolean;
};

export function FormNumber({
  name,
  label,
  hint,
  requiredMark,
  ...rest
}: FormNumberProps) {
  const { control } = useFormContext();
  const error = useFieldError(name);

  return (
    <Field name={name} label={label} hint={hint} requiredMark={requiredMark}>
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <Input
            id={name}
            type="number"
            aria-invalid={!!error}
            value={field.value ?? ""}
            onChange={(event) => {
              const next = event.target.value;
              field.onChange(
                next === "" ? undefined : Number(next),
              );
            }}
            onBlur={field.onBlur}
            ref={field.ref}
            {...rest}
          />
        )}
      />
    </Field>
  );
}
